export const getCustomNoOptionText = ({
  inputValue,
  isLoading,
  options,
  label,
}: {
  inputValue: string
  isLoading: boolean
  options: any[]
  label: string
}) => {
  if (inputValue === '') {
    return `Start typing for your ${label}`
  }
  if (isLoading) {
    return 'Loading...'
  }
  if (options.length === 0) {
    return `No ${label} found`
  }
  return ''
}
